import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Rol } from '@core/model/rol.model';
import { User } from '@core/model/user.model';
import { UserService } from '@app/core';
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons
} from '@ng-bootstrap/ng-bootstrap';
import { UsuarioCreateComponent } from '@app/dashboard/usuarios/usuario-create/usuario-create.component';
import { UsuarioEditComponent } from '../usuario-edit/usuario-edit.component';

@Component({
  selector: 'app-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.css']
})
export class UsuarioListComponent implements OnInit {
  userForm: FormGroup;
  roles2: Rol[];
  editRoles: Rol[];
  users: User[];
  selectedRols: any[];
  usuario: any = {};
  modalOptions: NgbModalOptions;
  closeResult: string;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private modalService: NgbModal
  ) {
    this.selectedRols = new Array();
    this.roles2 = new Array();
    this.editRoles = new Array();

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    };
  }

  ngOnInit() {
    this.listarRoles();
    this.listarUsers();
    this.createForm();
  }

  listarRoles() {
    this.userService.getAllRoles().subscribe(
      data => {
        this.roles2 = data;
        console.log(this.roles2);
      },
      error => {
        console.log('error' + error);
      }
    );
  }

  listarUsers() {
    this.userService.getAll().subscribe(
      data => {
        this.users = data;
        console.log(this.users);
      },
      error => {
        console.log('Error' + error.error);
      }
    );
  }

  createForm() {
    this.userForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      nombres: ['', Validators.required],
      apellidos: ['', Validators.required],
      ci: ['', Validators.required],
      roles: this.buildRoles()
    });
  }

  get roles() {
    return this.userForm.get('roles');
  }

  buildRoles() {
    const arr = this.roles2.map((rol: any) => {
      return this.formBuilder.control(rol.enabled);
    });

    console.log(arr);
    return this.formBuilder.array(arr);
  }

  selectedRoles(e: any, id: number) {
    const objetoRol: any = {};

    if (e.target.checked) {
      objetoRol.id = id;

      this.selectedRols.push(objetoRol);
    } else {
      this.selectedRols.splice(this.selectedRols.indexOf(id), 1);
    }
  }

  enableUser(id: number) {
    this.userService.enableUser(id).subscribe(
      data => {
        this.listarUsers();
      },
      error => {
        console.log('error ' + error);
      }
    );
  }

  registerUser() {
    console.log(this.userForm.value.username);

    this.usuario.username = this.userForm.value.username;
    this.usuario.password = this.userForm.value.password;
    this.usuario.email = this.userForm.value.email;
    this.usuario.nombres = this.userForm.value.nombres;
    this.usuario.apellidos = this.userForm.value.apellidos;
    this.usuario.ci = this.userForm.value.ci;

    this.usuario.roles = this.selectedRols;

    console.log(this.usuario);
    this.userService.create(this.usuario).subscribe(
      data => {
        alert('Fue creado satisfactoriamente');

        this.listarUsers();
      },
      (error: any) => {
        alert('error');
      }
    );
  }

  editarUsuario(id: string) {
    const modalRef = this.modalService.open(
      UsuarioEditComponent,
      this.modalOptions
    );

    modalRef.componentInstance.id = id;
    modalRef.componentInstance.roles3 = this.roles2;

    modalRef.result.then(result => {
      if (result) {
        this.listarUsers();
      }
    });
  }

  private rolesList(roles: any) {
    const array = roles.map((rol: any) => {
      return this.formBuilder.control(rol.enabled);
    });
    console.log(array);

    return this.formBuilder.array(array);
  }

  createUser() {
    const modalRef = this.modalService.open(
      UsuarioCreateComponent,
      this.modalOptions
    );

    modalRef.componentInstance.roles3 = this.roles2;
    modalRef.result.then(result => {
      if (result) {
        this.listarUsers();
      }
    });
  }
}
